import { INITIAL_LANGUAGE, AVAILABLE_LANGUAGES, AVAILABLE_DATE_I18N, setLanguage } from '@/$plugins/i18n/languages'

import base from '../base'
import IS from '../base/is'

export default {
    namespaced: true,
    state: base.createState(IS.state, {
        language: {
            active: INITIAL_LANGUAGE,
            available: AVAILABLE_LANGUAGES,
            dateLanguage: AVAILABLE_DATE_I18N[INITIAL_LANGUAGE.substr(0, 2)],
            dateLanguageAvailable: AVAILABLE_DATE_I18N
        },
        searchEntityKey: null
    }),
    getters: base.createGetters(IS.getters, {
        getLanguage: state => state.language.active,
        getLooseLanguage: state => state.language.active.substr(0, 2),
        getLanguagesAvailable: state => state.language.available,
        getDateLanguage: state => state.language.dateLanguage,
        getDateLanguageAvailable: state => state.language.dateLanguageAvailable,

        getSearchEntityKey: state => state.searchEntityKey
    }),
    mutations: base.createMutations(IS.mutations, {
        setLanguage (state, language = '') {
            state.language.active = setLanguage(language)
            state.language.dateLanguage = AVAILABLE_DATE_I18N[state.language.active.substr(0, 2)]
        },
        setSearchEntityKey (state, key = null) {
            state.searchEntityKey = key
        }
    }),
    actions: base.createActions(IS.actions, {})
}
